<template>
  <div class="forgot-password">
    <el-col :xs="{span: 20, offset: 1}" :sm="{span: 12, offset:6}">

      <div class="panelheader">
        <div class="title">Reset your password</div>
      </div>

      <div class="body">
        <el-form :model="fpForm" :rules="rules" ref="fpForm" v-loading="showLoading">
          <el-form-item prop="email" class="fpEmailInput">
            <el-input type="email"
              v-model="fpForm.email"
              placeholder="Email"
              @keydown.tab.native="submitForm"
              @keydown.enter.native="submitForm">
            </el-input>
          </el-form-item>

          <p> Please fill in the email that you used to register. </p>
          <p> You will be sent an email with instructions on how to reset your password. </p>

          <el-form-item>
            <el-button type="save" :class="{incorrect: !validEmail}" @click="submitForm('fpForm')">Send Email</el-button>
          </el-form-item>
        </el-form>

        <strong>
          Remember your password?
          <span @click="$router.push('/login')" class="signInLink">Sign in</span>
        </strong>
      </div>
    </el-col>
  </div>
</template>

<script>

import { debounce } from 'lodash';
import requests from '../requests';

export default {
  name: "forgot-password",
  data() {
    var validateEmail = (rule, value, callback) => {
      var emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if(!value.trim().match(emailRegex)) {
        callback(new Error('Please enter a valid email.'));
        return
      }
      callback();
    };

    return {
      showLoading: false,
      validEmail: false,
      fpForm: {
        email: '',
      },
      rules: {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      },
    }
  },
  beforeMount() {

  },
  methods: {
    submitForm(form) {
      if(form instanceof Event) {
        form.preventDefault();
        form = 'fpForm';
      }

      this.$refs[form].validate( (valid) => {
        if(!valid) {
          return false;
        }

        this.showLoading = true;

        var context = this;
        requests.getUserByEmail(this, this.fpForm.email, function(result) {
          console.log(result)
          context.showLoading = false;
          if(result.action == 'fail') {
            if(result.msg == "Retrieved multiple rows") {
              context.$message({type: 'error', 'message': 'Multiple accounts with that email. Please contact support.'})
            } else {
              context.$message({showClose: true, type: 'error', 'message': result.msg})              
            }
          } else if(result.msg == "No_result" || !result.data) {
              context.$message({showClose: true, type: 'error', 'message': 'No account found with that email.'})              
          } else {
            context.sendFPEmail(result.data);
          }
        });

      });
    },
    sendFPEmail(data){
      var context = this;
      requests.sendFPEmail(this, data, function (result) {
        var email = Object.assign({}, data).email;
        console.log(result);
        if(result.action === 'success') {
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Email sent to ' + email
          });
        } else {
          context.$message({
            showClose: true,
            type: 'error',
            message: result.msg
          });
        }
      });
    }
  },
  watch: {
    'fpForm.email':debounce(function(val) {
      this.$refs['fpForm'].validate((valid) => {
        this.validEmail = valid;
      });
    }, 200),
  }
}
</script>

<style>
  .fpEmailInput {
    margin: 20px auto;
  }

  .body {
    background: white;
    padding: 8px;
  }

  .incorrect {
    background: #254863;
    color: #BBBBBB
  }

  .signInLink {
    color: #6CA5E7;
    text-decoration: underline;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?4e0c5f71